import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IGroomerStaffCreateBody } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useConfigurationGroomerStaffCreateAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (body: IGroomerStaffCreateBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios.post<AxiosResponse>(CONFIGURATION_APIS.GROOMER_STAFF_CREATE.baseURL, body, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        toast.success(body?.groomer_id ? "Groomer updated successfully" : "Groomer created successfully");
        return response.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        } else {
          toast.error("Failed to create groomer");
        }
        throw error;
      }
    },
    [captureError, configuration, sendCurl],
  );

  return { execute };
};
